import { render, staticRenderFns } from "./clientProfileTrainingCourses.vue?vue&type=template&id=955e0b68"
import script from "./clientProfileTrainingCourses.vue?vue&type=script&lang=js"
export * from "./clientProfileTrainingCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports